export function formatPhone(phone: string) {
    let cleaned = phone.replace(/\D/g, '')

    if (cleaned.length === 11) {
        if (cleaned[0] === '8') {
            cleaned = '7' + cleaned.slice(1)
        }
        // Форматируем: +7 999 999 99 99
        return `+7 ${cleaned.slice(1, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7, 9)} ${cleaned.slice(9)}`
    } else if (cleaned.length === 10) {
        // Если номер без кода страны (10 цифр)
        return `+7 ${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 8)} ${cleaned.slice(8)}`
    } else {
        return phone
    }
}
